import s from './FAQ.module.css'
import cn from 'classnames'
import { IFAQ } from './IFAQ';
import { ISectionBuilder } from './section/ISection';
import Section from './section';
import Image from 'next/image'
import { IQuestionBuilder } from './question/IQuestion'
import { faqSectionQuestions } from './faqQuestions'
import { Faqs } from 'graphcms/models/section';
const voidFn = () => { };
import parse from 'html-react-parser';
import { ReactElement } from 'react';


const FaqTemplate = ({ sections, title }: { sections: ISectionBuilder[], title?: string }) => {
    const faqSections = sections.map(sect => Section(sect));
    return <>
        {title && <h2 className={cn(s.header)} id="faqs_section">{title}</h2>}
        <div
            className={cn(s.root)}
        >
            <ul
                className={cn(s.topics)}
            >
                {
                    faqSections.map(fs => {
                        return fs.getSelector(faqSections.map(fns => {
                            if (fns == fs) return voidFn;
                            return fns.unSelect
                        }))
                    })
                }
            </ul>
            <div className={cn(s.faqs)}>
                {
                    faqSections.map(fs => fs.getSection)
                }
            </div>
        </div>
    </>
}

const FAQ: IFAQ = ({ faqs }: { faqs: Faqs }) => {
    let sections: ISectionBuilder[] = faqs.odQuestionSections.map((odSect,i) => {
        return {
            preShown : i == 0, 
            description: odSect.subtitle,
            icon: <Image
                src={odSect.image.url}
                alt = {odSect.image.alt}
                width="30"
                height="30"
                layout="intrinsic"
            />,
            title: odSect.title,
            questions: odSect.odQuestions.map((q) => {
                let questionb: IQuestionBuilder = {
                    question: q.question,
                    answer: parse(q.answer.html) as ReactElement
                }
                return questionb
            })
        }
    })
    return <FaqTemplate
        sections={sections}
        title={faqs.title}
    />
}

export default FAQ;